import initStore from '@/stores/init';
import agentStore from '@/stores/agent';
import { INHOUSE_MESSAGE_TYPE } from '@/types/common';

// 页面非active状态消息数量
let pageInactiveMsgCount = 0;
let pageInactiveUnreadMsgPos: number | undefined;

export function handlePageInactiveForPN(data: any) {
  const msgType = data.msg_type;
  const blackList = [
    INHOUSE_MESSAGE_TYPE.NEW_SESSION,
    INHOUSE_MESSAGE_TYPE.QUEUING,
    INHOUSE_MESSAGE_TYPE.AGENT_TYPING,
    INHOUSE_MESSAGE_TYPE.AGENT_NOT_TYPING,
  ];
  // 当前页面不在active状态
  if (initStore.isPageActive === false) {
    data._useAfterDialogueShow_ = false;
    if (!blackList.includes(msgType)) {
      agentStore.updateHasUnreadMsgWhenPageInactive(true);

      if (pageInactiveUnreadMsgPos === undefined) {
        pageInactiveUnreadMsgPos = agentStore.ADD_AGENT_DATA_ITEM({
          from: 'system',
          type: 'UnreadMessages',
          data: { num: ++pageInactiveMsgCount },
          _useAfterDialogueShow_: false,
        });
      } else {
        agentStore.UPDATE_AGENT_DATA_ITEM({ num: ++pageInactiveMsgCount }, pageInactiveUnreadMsgPos);
      }
    }
  } else {
    clearPageInactiveData();
  }
}

export function clearPageInactiveData() {
  pageInactiveMsgCount = 0;
  pageInactiveUnreadMsgPos = undefined;
  agentStore.updateHasUnreadMsgWhenPageInactive(false);
}
